import { Typography } from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import { getAllVoucherDataByDate } from "../../../utils/endPoints";
// import './styles.css';
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TrialHeader from "../../../components/Accounts/Account/trialheader";
import Loader from "../../../components/Accounts/Loader";
import Report from "../../../components/Accounts/Reports/report";
import {
  calculateOpeningBalance,
  getTodayVouchers,
  parseIntFunction,
} from "../../../utils/Level/utils";

function CashBook() {
  const level_3 = useSelector((state) => state.accountLevels.level3);
  const isMediumScreen = useMediaQuery("(min-width: 960px)");
  const [trialData, setTrialData] = useState({});
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [loading, setLoading] = useState(false);

  async function getTrialData(startDate) {
    try {
      setLoading(true);
      const date = new Date(startDate);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      const formattedDate = `${day}-${month}-${year}`;

      startDate = moment(startDate, "DD-MM-YYYY");
      let refPromises = [];
      let headerData = {};
      let cashArray = [];
      let saleArray = [];
      let bankArray = [];
      let journalArray = [];
      let bankOpenningBalance = 0;
      let cashOpenningBalance = 0;

      level_3.forEach(async (code) => {
        let result = getAllVoucherDataByDate(code.fullcode, formattedDate).then(
          (vouchers) => {
            if (code.type === "BANK") {
              bankOpenningBalance =
                bankOpenningBalance + parseIntFunction(code.amount);
              bankArray.push(vouchers);
            } else if (code.type === "CASH") {
              cashArray.push(vouchers);
              cashOpenningBalance =
                cashOpenningBalance + parseIntFunction(code.amount);
            } else if (code.type === "CLIENT" || code.type === "SALE" ) {
              saleArray.push(vouchers);
            } else {
              if(vouchers.length > 0){
                console.log(code.type,vouchers)

              }

              journalArray.push(vouchers);
            }
          }
        );
        refPromises.push(result);
      });
      await Promise.all(refPromises);
let bankDebit = 0,
        cashDebit = 0,
        bankCredit = 0,
        cashCredit = 0,
        todayBankCredit = 0,
        todayBankDebit = 0,
        todayCashCredit = 0,
        todayCashDebit = 0,
        todaySaleCredit = 0,
        todaySaleDebit = 0,
        todayJournalCredit = 0,
        todayJournalDebit = 0;
      let todayBankVoucherArr = [];
      let todayCashVoucherArr = [];
      let todaySaleVoucherArr = [];
      let todayJournalVoucherArr = [];
      let todayVoucherRowArr = [];
      bankArray.filter((arr) => arr.length > 0);
      bankArray.forEach((item) => {
        let arr = calculateOpeningBalance(item, startDate);
        todayBankVoucherArr = getTodayVouchers(item, startDate, "");
        todayBankDebit = todayBankDebit + todayBankVoucherArr[1];
        todayBankCredit = todayBankCredit + todayBankVoucherArr[0];
        bankDebit = bankDebit + arr[1];
        bankCredit = bankCredit + arr[0];
        todayVoucherRowArr = todayVoucherRowArr.concat(todayBankVoucherArr[2]);
      });
      cashArray.forEach((item) => {
        let arr = calculateOpeningBalance(item, startDate);
        todayCashVoucherArr = getTodayVouchers(item, startDate, "");
        todayCashDebit = todayCashDebit + todayCashVoucherArr[1];
        todayCashCredit = todayCashCredit + todayCashVoucherArr[0];
        cashDebit = cashDebit + arr[1];
        cashCredit = cashCredit + arr[0];
        todayVoucherRowArr = todayVoucherRowArr.concat(todayCashVoucherArr[2]);
      });
      saleArray.forEach((item) => {
        todaySaleVoucherArr = getTodayVouchers(item, startDate, "");
        todaySaleDebit = todaySaleDebit + todaySaleVoucherArr[1];
        todaySaleCredit = todaySaleCredit + todaySaleVoucherArr[0];
        todayVoucherRowArr = todayVoucherRowArr.concat(todaySaleVoucherArr[2]);
      });
      journalArray.forEach((item) => {
        todayJournalVoucherArr = getTodayVouchers(item, startDate, "j");
        todayJournalDebit = todayJournalDebit + todayJournalVoucherArr[1];
        todayJournalCredit = todayJournalCredit + todayJournalVoucherArr[0];
        todayVoucherRowArr = todayVoucherRowArr.concat(
          todayJournalVoucherArr[2]
        );
      });
      console.log(todayVoucherRowArr)

      bankOpenningBalance = bankOpenningBalance - bankCredit + bankDebit;
      cashOpenningBalance = cashOpenningBalance - cashCredit + cashDebit;
      headerData.cashOpenningBalance = cashOpenningBalance;
      headerData.bankOpenningBalance = bankOpenningBalance;
      headerData.cashReceived = todayCashDebit;
      headerData.bankReceived = todayBankDebit;
      headerData.cashPaid = todayCashCredit;
      headerData.bankPaid = todayBankCredit;
      headerData.saleReceived = todaySaleDebit;
      headerData.salePaid = todaySaleCredit;
      headerData.journalReceived = todayJournalDebit;
      headerData.journalPaid = todayJournalCredit;



      

      todayVoucherRowArr.sort((a, b) => {
        const dateA = new Date(a.voucherDate).getTime();
        const dateB = new Date(b.voucherDate).getTime();

        if (dateA === dateB) {
          return a.voucherNumber - b.voucherNumber;
        }

        return dateA - dateB;
      });
      openReport(startDate, todayVoucherRowArr, headerData);
      setLoading(false);
    } catch {
      setLoading(false);
    }
  }

  function openReport(startDate, todayVoucherRowArr, headerData) {
    var trialObj = {
      id: "617fb229f661460020535df3",
      invoice_no: "202010-93",
      invoice: todayVoucherRowArr,
      headerData,
      titleData: {
        // heading: user?.companyname,
        title:
          "Daily Cash Book " +
          new Date(startDate).toLocaleString().split(",")[0],
        subTitle: " ",

        leftTitle: "",
        leftSubTitle: "",
        rightTitle: "",
        rightSubTitle: "",
      },
      docType: "CashBook",
      from: "",
      to: "",
      codeDetails: {
        codeLevel2: "",
        descLevel2: "",
        codeLevel3: "",
        descLevel3: "",
      },
      totalDebit: "",
      totalCredit: "",
      balance: "",
      openingBalance: "",
      level3Array: level_3,
    };
    console.log(trialObj);
    setTrialData(trialObj);
    handleOpen();
    setLoading(false);
  }

  return (
    <div>
      <Loader loading={loading} />
      {/* <OverlayLoader open={loading}/> */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginTop: "1rem",
          justifyContent: "center",
          // backgroundColor: '#5CDB95',
        }}
      >
        <ToastContainer
          position="bottom-center"
          autoClose={2000}
          hideProgressBar={true}
          closeOnClick={true}
          progress={undefined}
        />

        <Typography variant="h5" component="h2" gutterBottom>
          Cash Book
        </Typography>

        <TrialHeader
          searchCallback={(startDate) => {
            getTrialData(startDate);
          }}
        ></TrialHeader>
        <Report open={open} handleClose={handleClose} data={trialData} />
      </div>
    </div>
  );
}

export default CashBook;
